import { animate, state, style, transition } from '@angular/animations';

export const expansionAnimation = [
  state(
    'open',
    style({
      height: '*',
      opacity: 1,
    }),
  ),
  state(
    'closed',
    style({
      height: '0',
      opacity: 0,
    }),
  ),
  transition('open <=> closed', [animate('0.2s')]),
];
